module.exports = __webpack_public_path__ + "static/media/dungeon_floor_ne2.ca26a946.png";